import { useMutation } from '@apollo/client/react';

import type { Kitchen } from '../../libs';
import { COMPLETE_TASK_MUTATION } from '../../libs/graphQL';

type CompleteTaskData = { completeTask: { id: string; doneAt: string } };
type CompleteTaskVars = { kitchen: Kitchen; id: string };

// The task shows as done at once; a failed call rolls it back, and `error` says so.
const useCompleteTask = (kitchen: Kitchen, id: string) => {
  const [mutate, { loading, error }] = useMutation<CompleteTaskData, CompleteTaskVars>(COMPLETE_TASK_MUTATION, {
    optimisticResponse: () => ({ completeTask: { __typename: 'Task', id, doneAt: new Date().toISOString() } }) as CompleteTaskData
  });
  return {
    complete: () => {
      mutate({ variables: { kitchen, id } }).catch(() => {});
    },
    pending: loading,
    failed: error !== undefined
  };
};

export default useCompleteTask;
